import { createContext, useCallback, useContext, useEffect, useState } from "react";
import AppProps from "../static/js/AppProps";

const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const login = useCallback((userData, token) => {
        setUser(userData);
        localStorage.setItem("token", token);
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem("token");
        setUser(null);
    }, []);

    const checkAuth = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            setLoading(false);
            return;
        }

        try {
            const validateRes = await fetch(`${AppProps.spring_server_url}/auth/validate`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });

            if (!validateRes.ok) {
                console.warn("Token validation failed:", validateRes.status);
                logout();
                return;
            }

            const userResponse = await fetch(`${AppProps.spring_server_url}/user`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (userResponse.ok) {
                const userData = await userResponse.json();
                setUser(userData);
            } else {
                console.warn("User endpoint returned:", userResponse.status);
                logout();
            }

        } catch (error) {
            console.error("Ошибка при валидации токена:", error);
            logout();
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        checkAuth();
    }, []);

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
